import Vue from 'vue'

export const namespaced = true

export const state = {
  datas: {
    paiementOnTime: {},
    daysOfPaymentTerms: {},
    ongoingBills: {},
    turnoverBars: {},
    timelineData: {}
  },
  dashboardLoading: true
}

//MUTATIONS are synchronous : mutate / update state => this.$store.commit('ADD_EVENT')
export const mutations = {

  SET_DASHBOARD_DATA (state, datas) {
    state.datas = datas
  },

  SET_DASHBOARD_LOADING (state, loading) {
    state.dashboardLoading = loading
  }
}

//ACTIONS are assynchronous : actions fetch datas (AJAX) then send results to mutations (to update local state)  => this.$store.dispatch('createEvent')
export const actions = {

  getDatas ({commit, dispatch}) {
    commit('SET_DASHBOARD_LOADING', true)
    return Vue.axios.get('/dashboard')
      .then(response => {
        commit('SET_DASHBOARD_DATA', response.data)
        commit('SET_DASHBOARD_LOADING', false)
      })
      .catch(error => {
        commit('SET_DASHBOARD_LOADING', false)
        dispatch('displayError', {message: 'Erreur de chargement du dashboard', error}, {root: true})
      })
  }
}
